<template>
  <div v-if="message" class="overlay" @click="hideMessage">
    <div class="message" @click.stop>
      <p>{{ message }}</p>
      <!-- TODO: Translate button -->
      <button @click="hideMessage">Dismiss</button>
    </div>
  </div>
</template>

<script>

import useMessages from "@/composables/useMessages";

export default {
  setup() {
    const { message, hideMessage } = useMessages();

    return { message, hideMessage };
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
}

.message {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
}
</style>
